import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import {
  applyDiscountApi,
  deleteDiscountApi,
  getVendorDiscountsApi,
  getAllDiscountsAdminApi
} from "../../../../services/Web/discount.service"

import { toastError, toastSuccess } from "../../../../utility/toastutill"

// -----------------------------------
// 👤 Vendor → Get own discount list
// -----------------------------------
export const getVendorDiscounts = createAsyncThunk(
  "discount/getVendorDiscounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getVendorDiscountsApi()
      return res.data.data
    } catch (error) {
      console.log("Error fetching vendor discounts:", error)
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// -----------------------------------
// 🛑 Admin → Get all discounts
// -----------------------------------
export const getAdminDiscounts = createAsyncThunk(
  "discount/getAdminDiscounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAllDiscountsAdminApi()
      return res.data.data
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// -----------------------------------
// ➕ Apply Discount Rule (Create)
// -----------------------------------
export const applyDiscount = createAsyncThunk(
  "discount/applyDiscount",
  async (formData, { dispatch, getState, rejectWithValue }) => {
    try {
      const res = await applyDiscountApi(formData)

      if (res?.data?.success === false) {
        toastError(res.data.message)
        return rejectWithValue(res.data.message)
      }

      toastSuccess("Discount rule applied successfully")

      // Refresh lists
      if (getState().auth.userData.role === "ADMIN") {
        dispatch(getAdminDiscounts())
      } else {
        dispatch(getVendorDiscounts())
      }

      return res.data.data
    } catch (error) {
      console.log("Error applying discount:", error)
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"
      toastError(msg)
      return rejectWithValue(msg)
    }
  }
)

// -----------------------------------
// ❌ Delete Discount Rule
// -----------------------------------
export const deleteDiscount = createAsyncThunk(
  "discount/deleteDiscount",
  async (id, { dispatch, getState, rejectWithValue }) => {
    try {
      await deleteDiscountApi(id)
      toastSuccess("Discount removed successfully")

      if (getState().auth.userData.role === "ADMIN") {
        dispatch(getAdminDiscounts())
      } else {
        dispatch(getVendorDiscounts())
      }

      return true
    } catch (error) {
      toastError(error)
      return rejectWithValue(error)
    }
  }
)

// -----------------------------------
// Slice
// -----------------------------------
export const discountSlice = createSlice({
  name: "discount",
  initialState: {
    loading: false,
    data: [],
    adminData: [],
    success: false
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVendorDiscounts.pending, (state) => {
        state.loading = true
      })
      .addCase(getVendorDiscounts.fulfilled, (state, action) => {
        state.data = action.payload
        state.loading = false
      })
      .addCase(getAdminDiscounts.pending, (state) => {
        state.loading = true
      })
      .addCase(getAdminDiscounts.fulfilled, (state, action) => {
        state.adminData = action.payload
        state.loading = false
      })
      .addCase(applyDiscount.fulfilled, (state) => {
        state.success = true
      })
      .addCase(deleteDiscount.fulfilled, (state) => {
        state.success = true
      })
  }
})

export default discountSlice.reducer
